/* THIS IS A GENERATED FILE. PLEASE DO NOT MODIFY!! */
import * as Types from '../../../../types/dashboard-core-gqlTypes.generated.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type RailzIntegrationFragmentGQLType = (
  { __typename?: 'RailzIntegration' }
  & Pick<Types.RailzIntegrationGQLType, 'id' | 'railzBusinessId' | 'railzConnectionId' | 'railzServiceName' | 'organizationId' | 'created_at' | 'deletedAt'>
);

export type GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
}>;


export type GetActiveRailzConnectionsByOrgIdQueryGQLType = (
  { __typename?: 'Query' }
  & { connections: Array<(
    { __typename?: 'RailzIntegration' }
    & RailzIntegrationFragmentGQLType
  )> }
);

export type GetFinancialStatementDataByDateRangeQueryVariablesGQLType = Types.Exact<{
  startDate: Types.Scalars['FullDateStr'];
  endDate: Types.Scalars['FullDateStr'];
  financialStatement: Types.FinancialStatementTypeGQLType;
  reportFrequency: Types.ReportFrequencyGQLType;
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type GetFinancialStatementDataByDateRangeQueryGQLType = (
  { __typename?: 'Query' }
  & { getFinancialStatementDataByDateRange?: Types.Maybe<(
    { __typename?: 'FinancialStatementInstanceType' }
    & Pick<Types.FinancialStatementInstanceTypeGQLType, 'currency' | 'finleyStatementKey' | 'reportFrequency'>
    & { metadata: (
      { __typename?: 'FinancialStatementMetadata' }
      & Pick<Types.FinancialStatementMetadataGQLType, 'sortedEndOfPeriodDates'>
    ), adHocCalculations: Array<(
      { __typename?: 'FinancialStatementAdHocCalculations' }
      & Pick<Types.FinancialStatementAdHocCalculationsGQLType, 'adHocKey'>
      & { totals: Array<(
        { __typename?: 'FinancialSectionTotals' }
        & Pick<Types.FinancialSectionTotalsGQLType, 'cadenceDelta' | 'endOfPeriodDate' | 'value'>
      )> }
    )>, sectionKeysToLineItems: Array<(
      { __typename?: 'FinancialStatementSectionKeysToLineItems' }
      & Pick<Types.FinancialStatementSectionKeysToLineItemsGQLType, 'finleySectionKey'>
      & { totals: Array<(
        { __typename?: 'FinancialSectionTotals' }
        & Pick<Types.FinancialSectionTotalsGQLType, 'cadenceDelta' | 'endOfPeriodDate' | 'value'>
      )>, lineItemsToValues: Array<(
        { __typename?: 'FinancialStatementLineItemsToValuesTypes' }
        & Pick<Types.FinancialStatementLineItemsToValuesTypesGQLType, 'lineItemDescription'>
        & { values: Array<(
          { __typename?: 'FinancialStatementValueTypes' }
          & Pick<Types.FinancialStatementValueTypesGQLType, 'cadenceDelta' | 'endOfPeriodDate' | 'value' | 'finStatementLineItemId' | 'finStatementId'>
        )> }
      )> }
    )> }
  )> }
);

export type DoesFinancialsAthenaTableExistQueryVariablesGQLType = Types.Exact<{
  creditFacilityId: Types.Scalars['UUID'];
}>;


export type DoesFinancialsAthenaTableExistQueryGQLType = (
  { __typename?: 'Query' }
  & Pick<Types.QueryGQLType, 'doesFinancialsAthenaTableExist'>
);

export type CreateRailzIntegrationMutationVariablesGQLType = Types.Exact<{
  organizationId: Types.Scalars['UUID'];
  railzBusinessId: Types.Scalars['String'];
  railzConnectionId: Types.Scalars['String'];
  railzServiceName: Types.RailzAccountingServiceNamesGQLType;
}>;


export type CreateRailzIntegrationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { connection: (
    { __typename?: 'RailzIntegration' }
    & RailzIntegrationFragmentGQLType
  ) }
);

export type DisconnectRailzIntegrationMutationVariablesGQLType = Types.Exact<{
  railzIntegrationId: Types.Scalars['UUID'];
}>;


export type DisconnectRailzIntegrationMutationGQLType = (
  { __typename?: 'Mutation' }
  & { connection: (
    { __typename?: 'RailzIntegration' }
    & RailzIntegrationFragmentGQLType
  ) }
);

export type FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType = Types.Exact<{
  railzIntegrationId: Types.Scalars['UUID'];
  queryParamInputs: Types.RailzFinancialApiQueryParamsGQLType;
}>;


export type FetchAndUploadFinancialDataFromRailzMutationGQLType = (
  { __typename?: 'Mutation' }
  & { dataCount: Types.MutationGQLType['fetchAndUploadFinancialDataFromRailz'] }
);

export type UpdateFinStatementLineItemMutationVariablesGQLType = Types.Exact<{
  updateInput: Types.UpdateFinStatementLineItemInputGQLType;
}>;


export type UpdateFinStatementLineItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { updateFinStatementLineItem: (
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  ) }
);

export type CreateFinStatementLineItemMutationVariablesGQLType = Types.Exact<{
  finStatementLineItem: Types.CreateFinStatementLineItemInputGQLType;
}>;


export type CreateFinStatementLineItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { createFinStatementLineItem: (
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  ) }
);

export type DeleteFinStatementLineItemMutationVariablesGQLType = Types.Exact<{
  finStatementLineItemId: Types.Scalars['UUID'];
}>;


export type DeleteFinStatementLineItemMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deleteFinStatementLineItem: (
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  ) }
);

export type DeleteFinStatementMutationVariablesGQLType = Types.Exact<{
  finStatementId: Types.Scalars['UUID'];
}>;


export type DeleteFinStatementMutationGQLType = (
  { __typename?: 'Mutation' }
  & { deleteFinStatement?: Types.Maybe<(
    { __typename?: 'ResponseWithString' }
    & Pick<Types.ResponseWithStringGQLType, 'response'>
  )> }
);

export const RailzIntegrationFragmentDocGQLType = gql`
    fragment RailzIntegration on RailzIntegration {
  id
  railzBusinessId
  railzConnectionId
  railzServiceName
  organizationId
  created_at
  deletedAt
}
    `;
export const GetActiveRailzConnectionsByOrgIdDocumentGQLType = gql`
    query GetActiveRailzConnectionsByOrgId($organizationId: UUID!) {
  connections: getActiveRailzConnectionsByOrgId(organizationId: $organizationId) {
    ...RailzIntegration
  }
}
    ${RailzIntegrationFragmentDocGQLType}`;

/**
 * __useGetActiveRailzConnectionsByOrgIdQuery__
 *
 * To run a query within a React component, call `useGetActiveRailzConnectionsByOrgIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActiveRailzConnectionsByOrgIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActiveRailzConnectionsByOrgIdQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useGetActiveRailzConnectionsByOrgIdQuery(baseOptions: Apollo.QueryHookOptions<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>(GetActiveRailzConnectionsByOrgIdDocumentGQLType, options);
      }
export function useGetActiveRailzConnectionsByOrgIdLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>(GetActiveRailzConnectionsByOrgIdDocumentGQLType, options);
        }
export type GetActiveRailzConnectionsByOrgIdQueryHookResult = ReturnType<typeof useGetActiveRailzConnectionsByOrgIdQuery>;
export type GetActiveRailzConnectionsByOrgIdLazyQueryGQLTypeHookResult = ReturnType<typeof useGetActiveRailzConnectionsByOrgIdLazyQueryGQLType>;
export type GetActiveRailzConnectionsByOrgIdQueryResultGQLType = Apollo.QueryResult<GetActiveRailzConnectionsByOrgIdQueryGQLType, GetActiveRailzConnectionsByOrgIdQueryVariablesGQLType>;
export const GetFinancialStatementDataByDateRangeDocumentGQLType = gql`
    query GetFinancialStatementDataByDateRange($startDate: FullDateStr!, $endDate: FullDateStr!, $financialStatement: FinancialStatementType!, $reportFrequency: ReportFrequency!, $creditFacilityId: UUID!) {
  getFinancialStatementDataByDateRange(
    startDate: $startDate
    endDate: $endDate
    financialStatement: $financialStatement
    reportFrequency: $reportFrequency
    creditFacilityId: $creditFacilityId
  ) {
    currency
    finleyStatementKey
    reportFrequency
    metadata {
      sortedEndOfPeriodDates
    }
    adHocCalculations {
      adHocKey
      totals {
        cadenceDelta
        endOfPeriodDate
        value
      }
    }
    sectionKeysToLineItems {
      finleySectionKey
      totals {
        cadenceDelta
        endOfPeriodDate
        value
      }
      lineItemsToValues {
        lineItemDescription
        values {
          cadenceDelta
          endOfPeriodDate
          value
          finStatementLineItemId
          finStatementId
        }
      }
    }
  }
}
    `;

/**
 * __useGetFinancialStatementDataByDateRangeQuery__
 *
 * To run a query within a React component, call `useGetFinancialStatementDataByDateRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialStatementDataByDateRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialStatementDataByDateRangeQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      financialStatement: // value for 'financialStatement'
 *      reportFrequency: // value for 'reportFrequency'
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useGetFinancialStatementDataByDateRangeQuery(baseOptions: Apollo.QueryHookOptions<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>(GetFinancialStatementDataByDateRangeDocumentGQLType, options);
      }
export function useGetFinancialStatementDataByDateRangeLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>(GetFinancialStatementDataByDateRangeDocumentGQLType, options);
        }
export type GetFinancialStatementDataByDateRangeQueryHookResult = ReturnType<typeof useGetFinancialStatementDataByDateRangeQuery>;
export type GetFinancialStatementDataByDateRangeLazyQueryGQLTypeHookResult = ReturnType<typeof useGetFinancialStatementDataByDateRangeLazyQueryGQLType>;
export type GetFinancialStatementDataByDateRangeQueryResultGQLType = Apollo.QueryResult<GetFinancialStatementDataByDateRangeQueryGQLType, GetFinancialStatementDataByDateRangeQueryVariablesGQLType>;
export const DoesFinancialsAthenaTableExistDocumentGQLType = gql`
    query doesFinancialsAthenaTableExist($creditFacilityId: UUID!) {
  doesFinancialsAthenaTableExist(creditFacilityId: $creditFacilityId)
}
    `;

/**
 * __useDoesFinancialsAthenaTableExistQuery__
 *
 * To run a query within a React component, call `useDoesFinancialsAthenaTableExistQuery` and pass it any options that fit your needs.
 * When your component renders, `useDoesFinancialsAthenaTableExistQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDoesFinancialsAthenaTableExistQuery({
 *   variables: {
 *      creditFacilityId: // value for 'creditFacilityId'
 *   },
 * });
 */
export function useDoesFinancialsAthenaTableExistQuery(baseOptions: Apollo.QueryHookOptions<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>(DoesFinancialsAthenaTableExistDocumentGQLType, options);
      }
export function useDoesFinancialsAthenaTableExistLazyQueryGQLType(baseOptions?: Apollo.LazyQueryHookOptions<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>(DoesFinancialsAthenaTableExistDocumentGQLType, options);
        }
export type DoesFinancialsAthenaTableExistQueryHookResult = ReturnType<typeof useDoesFinancialsAthenaTableExistQuery>;
export type DoesFinancialsAthenaTableExistLazyQueryGQLTypeHookResult = ReturnType<typeof useDoesFinancialsAthenaTableExistLazyQueryGQLType>;
export type DoesFinancialsAthenaTableExistQueryResultGQLType = Apollo.QueryResult<DoesFinancialsAthenaTableExistQueryGQLType, DoesFinancialsAthenaTableExistQueryVariablesGQLType>;
export const CreateRailzIntegrationDocumentGQLType = gql`
    mutation CreateRailzIntegration($organizationId: UUID!, $railzBusinessId: String!, $railzConnectionId: String!, $railzServiceName: RailzAccountingServiceNames!) {
  connection: createRailzIntegration(
    organizationId: $organizationId
    railzBusinessId: $railzBusinessId
    railzConnectionId: $railzConnectionId
    railzServiceName: $railzServiceName
  ) {
    ...RailzIntegration
  }
}
    ${RailzIntegrationFragmentDocGQLType}`;
export type CreateRailzIntegrationMutationFnGQLType = Apollo.MutationFunction<CreateRailzIntegrationMutationGQLType, CreateRailzIntegrationMutationVariablesGQLType>;

/**
 * __useCreateRailzIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateRailzIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRailzIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRailzIntegrationMutation, { data, loading, error }] = useCreateRailzIntegrationMutation({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      railzBusinessId: // value for 'railzBusinessId'
 *      railzConnectionId: // value for 'railzConnectionId'
 *      railzServiceName: // value for 'railzServiceName'
 *   },
 * });
 */
export function useCreateRailzIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateRailzIntegrationMutationGQLType, CreateRailzIntegrationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateRailzIntegrationMutationGQLType, CreateRailzIntegrationMutationVariablesGQLType>(CreateRailzIntegrationDocumentGQLType, options);
      }
export type CreateRailzIntegrationMutationHookResult = ReturnType<typeof useCreateRailzIntegrationMutation>;
export type CreateRailzIntegrationMutationResultGQLType = Apollo.MutationResult<CreateRailzIntegrationMutationGQLType>;
export type CreateRailzIntegrationMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateRailzIntegrationMutationGQLType, CreateRailzIntegrationMutationVariablesGQLType>;
export const DisconnectRailzIntegrationDocumentGQLType = gql`
    mutation DisconnectRailzIntegration($railzIntegrationId: UUID!) {
  connection: disconnectRailzIntegration(railzIntegrationId: $railzIntegrationId) {
    ...RailzIntegration
  }
}
    ${RailzIntegrationFragmentDocGQLType}`;
export type DisconnectRailzIntegrationMutationFnGQLType = Apollo.MutationFunction<DisconnectRailzIntegrationMutationGQLType, DisconnectRailzIntegrationMutationVariablesGQLType>;

/**
 * __useDisconnectRailzIntegrationMutation__
 *
 * To run a mutation, you first call `useDisconnectRailzIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectRailzIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectRailzIntegrationMutation, { data, loading, error }] = useDisconnectRailzIntegrationMutation({
 *   variables: {
 *      railzIntegrationId: // value for 'railzIntegrationId'
 *   },
 * });
 */
export function useDisconnectRailzIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectRailzIntegrationMutationGQLType, DisconnectRailzIntegrationMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectRailzIntegrationMutationGQLType, DisconnectRailzIntegrationMutationVariablesGQLType>(DisconnectRailzIntegrationDocumentGQLType, options);
      }
export type DisconnectRailzIntegrationMutationHookResult = ReturnType<typeof useDisconnectRailzIntegrationMutation>;
export type DisconnectRailzIntegrationMutationResultGQLType = Apollo.MutationResult<DisconnectRailzIntegrationMutationGQLType>;
export type DisconnectRailzIntegrationMutationOptionsGQLType = Apollo.BaseMutationOptions<DisconnectRailzIntegrationMutationGQLType, DisconnectRailzIntegrationMutationVariablesGQLType>;
export const FetchAndUploadFinancialDataFromRailzDocumentGQLType = gql`
    mutation FetchAndUploadFinancialDataFromRailz($railzIntegrationId: UUID!, $queryParamInputs: RailzFinancialApiQueryParams!) {
  dataCount: fetchAndUploadFinancialDataFromRailz(
    railzIntegrationId: $railzIntegrationId
    queryParamInputs: $queryParamInputs
  )
}
    `;
export type FetchAndUploadFinancialDataFromRailzMutationFnGQLType = Apollo.MutationFunction<FetchAndUploadFinancialDataFromRailzMutationGQLType, FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType>;

/**
 * __useFetchAndUploadFinancialDataFromRailzMutation__
 *
 * To run a mutation, you first call `useFetchAndUploadFinancialDataFromRailzMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFetchAndUploadFinancialDataFromRailzMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [fetchAndUploadFinancialDataFromRailzMutation, { data, loading, error }] = useFetchAndUploadFinancialDataFromRailzMutation({
 *   variables: {
 *      railzIntegrationId: // value for 'railzIntegrationId'
 *      queryParamInputs: // value for 'queryParamInputs'
 *   },
 * });
 */
export function useFetchAndUploadFinancialDataFromRailzMutation(baseOptions?: Apollo.MutationHookOptions<FetchAndUploadFinancialDataFromRailzMutationGQLType, FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<FetchAndUploadFinancialDataFromRailzMutationGQLType, FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType>(FetchAndUploadFinancialDataFromRailzDocumentGQLType, options);
      }
export type FetchAndUploadFinancialDataFromRailzMutationHookResult = ReturnType<typeof useFetchAndUploadFinancialDataFromRailzMutation>;
export type FetchAndUploadFinancialDataFromRailzMutationResultGQLType = Apollo.MutationResult<FetchAndUploadFinancialDataFromRailzMutationGQLType>;
export type FetchAndUploadFinancialDataFromRailzMutationOptionsGQLType = Apollo.BaseMutationOptions<FetchAndUploadFinancialDataFromRailzMutationGQLType, FetchAndUploadFinancialDataFromRailzMutationVariablesGQLType>;
export const UpdateFinStatementLineItemDocumentGQLType = gql`
    mutation UpdateFinStatementLineItem($updateInput: UpdateFinStatementLineItemInput!) {
  updateFinStatementLineItem(updateInput: $updateInput) {
    response
  }
}
    `;
export type UpdateFinStatementLineItemMutationFnGQLType = Apollo.MutationFunction<UpdateFinStatementLineItemMutationGQLType, UpdateFinStatementLineItemMutationVariablesGQLType>;

/**
 * __useUpdateFinStatementLineItemMutation__
 *
 * To run a mutation, you first call `useUpdateFinStatementLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinStatementLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinStatementLineItemMutation, { data, loading, error }] = useUpdateFinStatementLineItemMutation({
 *   variables: {
 *      updateInput: // value for 'updateInput'
 *   },
 * });
 */
export function useUpdateFinStatementLineItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateFinStatementLineItemMutationGQLType, UpdateFinStatementLineItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateFinStatementLineItemMutationGQLType, UpdateFinStatementLineItemMutationVariablesGQLType>(UpdateFinStatementLineItemDocumentGQLType, options);
      }
export type UpdateFinStatementLineItemMutationHookResult = ReturnType<typeof useUpdateFinStatementLineItemMutation>;
export type UpdateFinStatementLineItemMutationResultGQLType = Apollo.MutationResult<UpdateFinStatementLineItemMutationGQLType>;
export type UpdateFinStatementLineItemMutationOptionsGQLType = Apollo.BaseMutationOptions<UpdateFinStatementLineItemMutationGQLType, UpdateFinStatementLineItemMutationVariablesGQLType>;
export const CreateFinStatementLineItemDocumentGQLType = gql`
    mutation CreateFinStatementLineItem($finStatementLineItem: CreateFinStatementLineItemInput!) {
  createFinStatementLineItem(finStatementLineItem: $finStatementLineItem) {
    response
  }
}
    `;
export type CreateFinStatementLineItemMutationFnGQLType = Apollo.MutationFunction<CreateFinStatementLineItemMutationGQLType, CreateFinStatementLineItemMutationVariablesGQLType>;

/**
 * __useCreateFinStatementLineItemMutation__
 *
 * To run a mutation, you first call `useCreateFinStatementLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateFinStatementLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createFinStatementLineItemMutation, { data, loading, error }] = useCreateFinStatementLineItemMutation({
 *   variables: {
 *      finStatementLineItem: // value for 'finStatementLineItem'
 *   },
 * });
 */
export function useCreateFinStatementLineItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateFinStatementLineItemMutationGQLType, CreateFinStatementLineItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateFinStatementLineItemMutationGQLType, CreateFinStatementLineItemMutationVariablesGQLType>(CreateFinStatementLineItemDocumentGQLType, options);
      }
export type CreateFinStatementLineItemMutationHookResult = ReturnType<typeof useCreateFinStatementLineItemMutation>;
export type CreateFinStatementLineItemMutationResultGQLType = Apollo.MutationResult<CreateFinStatementLineItemMutationGQLType>;
export type CreateFinStatementLineItemMutationOptionsGQLType = Apollo.BaseMutationOptions<CreateFinStatementLineItemMutationGQLType, CreateFinStatementLineItemMutationVariablesGQLType>;
export const DeleteFinStatementLineItemDocumentGQLType = gql`
    mutation DeleteFinStatementLineItem($finStatementLineItemId: UUID!) {
  deleteFinStatementLineItem(finStatementLineItemId: $finStatementLineItemId) {
    response
  }
}
    `;
export type DeleteFinStatementLineItemMutationFnGQLType = Apollo.MutationFunction<DeleteFinStatementLineItemMutationGQLType, DeleteFinStatementLineItemMutationVariablesGQLType>;

/**
 * __useDeleteFinStatementLineItemMutation__
 *
 * To run a mutation, you first call `useDeleteFinStatementLineItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinStatementLineItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinStatementLineItemMutation, { data, loading, error }] = useDeleteFinStatementLineItemMutation({
 *   variables: {
 *      finStatementLineItemId: // value for 'finStatementLineItemId'
 *   },
 * });
 */
export function useDeleteFinStatementLineItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFinStatementLineItemMutationGQLType, DeleteFinStatementLineItemMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFinStatementLineItemMutationGQLType, DeleteFinStatementLineItemMutationVariablesGQLType>(DeleteFinStatementLineItemDocumentGQLType, options);
      }
export type DeleteFinStatementLineItemMutationHookResult = ReturnType<typeof useDeleteFinStatementLineItemMutation>;
export type DeleteFinStatementLineItemMutationResultGQLType = Apollo.MutationResult<DeleteFinStatementLineItemMutationGQLType>;
export type DeleteFinStatementLineItemMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteFinStatementLineItemMutationGQLType, DeleteFinStatementLineItemMutationVariablesGQLType>;
export const DeleteFinStatementDocumentGQLType = gql`
    mutation DeleteFinStatement($finStatementId: UUID!) {
  deleteFinStatement(finStatementId: $finStatementId) {
    response
  }
}
    `;
export type DeleteFinStatementMutationFnGQLType = Apollo.MutationFunction<DeleteFinStatementMutationGQLType, DeleteFinStatementMutationVariablesGQLType>;

/**
 * __useDeleteFinStatementMutation__
 *
 * To run a mutation, you first call `useDeleteFinStatementMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinStatementMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinStatementMutation, { data, loading, error }] = useDeleteFinStatementMutation({
 *   variables: {
 *      finStatementId: // value for 'finStatementId'
 *   },
 * });
 */
export function useDeleteFinStatementMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFinStatementMutationGQLType, DeleteFinStatementMutationVariablesGQLType>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFinStatementMutationGQLType, DeleteFinStatementMutationVariablesGQLType>(DeleteFinStatementDocumentGQLType, options);
      }
export type DeleteFinStatementMutationHookResult = ReturnType<typeof useDeleteFinStatementMutation>;
export type DeleteFinStatementMutationResultGQLType = Apollo.MutationResult<DeleteFinStatementMutationGQLType>;
export type DeleteFinStatementMutationOptionsGQLType = Apollo.BaseMutationOptions<DeleteFinStatementMutationGQLType, DeleteFinStatementMutationVariablesGQLType>;